
export const lpFrequencyShowOptions = [
    {
        key: 'once',
        name: 'Show LP Once'
    },
    {
        key: 'multiple',
        name: 'Allow LP To Be Seen Multiple Times'
    },
];

export const lpActionTemplateOptions = [
    {
        key: 'signup',
        name: 'Sign Up'
    },
    {
        key: 'login',
        name: 'Login'
    },
    {
        key: 'direct-link',
        name: 'Direct link'
    },
];

export const lpBannerOptions = [
    {
        key: 'html',
        name: 'Use HTML5'
    },
    {
        key: 'static',
        name: 'Use Static Image'
    },
];
